import { apiClient } from './client';

export interface Subscription {
  id: string;
  org_id: string;
  stripe_subscription_id?: string;
  stripe_customer_id?: string;
  status: 'active' | 'past_due' | 'canceled' | 'incomplete' | 'trialing' | 'pending';
  amount: number;
  extra_users: number;
  cancel_at_period_end: boolean;
  current_period_start?: string;
  current_period_end?: string;
  created_at: string;
}

export interface PaymentHistory {
  id: string;
  subscription_id?: string;
  stripe_payment_id: string;
  status: 'succeeded' | 'pending' | 'failed';
  amount: number;
  payment_method?: string;
  paid_at?: string;
  created_at: string;
}

export interface BillingStatus {
  subscription: Subscription | null;
  payments: PaymentHistory[];
  billing_exempt: boolean;
  is_trial: boolean;
  trial_end_date: string | null;
}

export const billingApi = {
  getStatus: async (): Promise<BillingStatus> => {
    return apiClient.get<BillingStatus>('/billing');
  },

  subscribe: async (): Promise<{ redirect_url: string }> => {
    return apiClient.post<{ redirect_url: string }>('/billing/subscribe');
  },

  cancel: async (): Promise<{ success: boolean }> => {
    return apiClient.post<{ success: boolean }>('/billing/cancel');
  },

  portal: async (): Promise<{ redirect_url: string }> => {
    return apiClient.post<{ redirect_url: string }>('/billing/portal');
  }
};
